module.exports = __webpack_public_path__ + "img/page2_1.71a8597b.png";